/**
 * React Query mutation hook for reordering ShowNotes blocks
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import httpClient from 'src/utilities/http-client'

interface BlockSequence {
  id: string
  sequence: number
}

/**
 * Reorder blocks via API
 */
async function reorderBlocks(
  showNotesID: string,
  blockSequences: BlockSequence[],
  basePath: string,
): Promise<void> {
  await httpClient.put(`/api/${basePath}/${showNotesID}/blocks/reorder`, {
    blockSequences,
  })
}

/**
 * Hook to reorder show notes blocks
 * Invalidates the blocks cache to refetch with confirmed new ordering
 */
export function useReorderBlocks(showNotesID: string, basePath: string) {
  let queryClient = useQueryClient()

  return useMutation({
    mutationFn: (blockSequences: BlockSequence[]) =>
      reorderBlocks(showNotesID, blockSequences, basePath),
    onSuccess: () => {
      // Refetch to confirm new ordering from server
      queryClient.invalidateQueries({
        queryKey: ['showNotesBlocks', basePath, showNotesID],
      })
    },
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to reorder blocks:', error)
    },
  })
}
